import { JobStatus, JobType, QueueType } from '@/app/context/GeneratorContext';
import axiosInstance from '@/lib/axios/axiosInstance';

// Define ModerationStatus enum
export enum ModerationStatus {
  None = 'none',
  Pending = 'pending',
  Passed = 'passed',
  Rejected = 'rejected'
}

export interface HistoryGeneration {
  _id: string;
  unwatermarked: string;
  saved: boolean;
  thumbnailUrl: string;
  videoUrl: string;
}

export interface HistoryJob {
  _id: string;
  userId: string;
  jobId: string;
  queueType: QueueType;
  tags: string[];
  customPrompt?: string;
  customNegative?: string;
  status: JobStatus;
  jobType: string;
  batchSize: number;
  cfgScale?: number;
  length?: string;
  generationIds: HistoryGeneration[];
  height: number;
  width: number;
  aspectRatio: string;
  generator: string;
  creditCost: number;
  subStarChange: number;
  ccBillChange: number;
  dailyChange: number;
  origin: number;
  createdAt: string;
  delayedUntil?: Date;
  moderationStatus: ModerationStatus;
}

export interface GetJobHistoryRes {
  response: HistoryJob[] | null;
  error: any;
}

export const getJobHistory = async (): Promise<HistoryJob[]> => {
  try {
    const response = await axiosInstance.get(`/job/history`);
    return response?.data || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};
